// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { AxiosError } from 'axios';

import type { ClientConfigOptions } from '../types.js';
import { objectKeysToCamelCase } from '../utils/objectKeysTo.js';

export function responseErrorDataToCamelCase(err: AxiosError) {
  if (err.response) {
    const config = err.response.config as {
      clientOptions?: ClientConfigOptions;
    };
    const camelCaseBody = config.clientOptions?.response?.camelCaseBody;
    if (camelCaseBody === false) {
      throw err;
    }
    throw {
      ...err,
      response: {
        ...err.response,
        // @ts-ignore TS2345: Argument of type 'unknown' is not assignable to parameter of type 'AxiosResponse<any, any>'.
        data: objectKeysToCamelCase(err.response.data),
      },
    };
  }
  throw err;
}
